export const ROLES = {
  SUPER_ADMIN: 1,
  MANAGER: 2,
  EMPLOYEE: 3,
};
